import { render, staticRenderFns } from "./ViewCommunication.vue?vue&type=template&id=126eaaca&"
import script from "./ViewCommunication.vue?vue&type=script&lang=js&"
export * from "./ViewCommunication.vue?vue&type=script&lang=js&"
import style0 from "./ViewCommunication.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports